var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-chip',_vm._g({attrs:{"color":_vm.color}},on),[_c('v-icon',{attrs:{"color":"white"}},[_vm._v(_vm._s(_vm.icono))])],1)]}}])},[_vm._v(" "+_vm._s(_vm.estadoName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }